import React, { Fragment, useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Row, Col, Card, Label, Button, CardBody, CardHeader, FormGroup, InputGroup, InputGroupText, CardTitle, Input } from 'reactstrap';
import webservice from '../../../Service/webservice';
import * as Yup from 'yup';
import { AesDecrypt, AesEncrypt, keyPromise } from '../../../Service/crypto';
import Breadcrumbs from "../../../CommonElements/Breadcrumbs/Breadcrumbs";
import { ErrorMessage, Field, FieldArray, Form, Formik } from 'formik';
import Select, { SingleValue } from 'react-select';
import Swal from 'sweetalert2';
import { v4 as uuidv4 } from 'uuid';
import { Edit2, Eye, EyeOff, Info, Lock, Plus, X } from 'react-feather';
import { useAppDispatch } from "../../../ReaduxToolkit/Hooks";
import { get_vendorname } from "./store"
import api from '../../../api';
import websocket_webservice from '../../../Service/websocket_webservice';
import { ChevronDown, ChevronRight } from 'react-feather';

interface FormValues {
  Website: string;
  Groups: string;
  MobileNo?: string;
  State: string;
  CompanyName: string;
  Address: any;
  City: string;
  Currency: string;
  ZipCode: string;
  Country: string;
  FirstName: string,
  LastName: string,
  Position: string,
  Companytype: string[],
  Email: string,
  Phone: string,
  Direction: string,
  Password: string,
  Providers: {
    firstName: string;
    middleName: string;
    lastName: string;
    providerId: string;
    providertaxId: string;
  }[];
  Group: {
    providerId: string;
  }[];

  Insurance: {
    insurance: string;
    Username: string;
    name: string;
    password: string;
    Software_Vendor: string;
    SoftwareName?: boolean; // Matches the property name from Insurance Master
    link: string;
    bot_status: string; // <-- Added bot_status field
    status: string; // <-- Added status field
  }[];
  allocation_vendor_name: any;
  promptsData?: any;
  system_prompt?: string; // Added system_prompt
  selectedFields: string[];
  fieldInstructions: Record<string, string>;
}

interface Iinsuranceoption {
  label: string;
  value: string;
  link: string;
  SoftwareName?: boolean;
  bot_status: string;

}
// === Prompt Type ===
interface Prompt {
  id: number;
  text: string;
}
const defaultValues: FormValues = {
  Website: '',
  Groups: '',
  MobileNo: '',
  CompanyName: '',
  Companytype: [],
  State: '',
  Address: [''],
  City: '',
  Currency: '',
  ZipCode: '',
  Country: 'US',
  FirstName: '',
  LastName: '',
  Position: '',
  Email: '',
  Phone: '',
  Direction: '',
  Password: '',
  Providers: [{ firstName: '', middleName: '', lastName: '', providerId: '', providertaxId: '' }],
  Insurance: [{ insurance: '', name: '', Username: '', password: '', Software_Vendor: '', SoftwareName: false, link: '', status: 'active', bot_status: '' }], // <-- Updated default
  Group: [{ providerId: '', }],
  allocation_vendor_name: [],
  system_prompt: '',
  selectedFields: [],
  fieldInstructions: {},
};

const CountryOptions = [
  { value: 'AF', label: 'Afghanistan' },
  { value: 'AX', label: 'Aland Islands' },
  { value: 'AL', label: 'Albania' },
  { value: 'DZ', label: 'Algeria' },
  { value: 'AS', label: 'American Samoa' },
  { value: 'AD', label: 'Andorra' },
  { value: 'AO', label: 'Angola' },
  { value: 'AI', label: 'Anguilla' },
  { value: 'AQ', label: 'Antarctica' },
  { value: 'AG', label: 'Antigua and Barbuda' },
  { value: 'AR', label: 'Argentina' },
  { value: 'AM', label: 'Armenia' },
  { value: 'AW', label: 'Aruba' },
  { value: 'AU', label: 'Australia' },
  { value: 'AT', label: 'Austria' },
  { value: 'AZ', label: 'Azerbaijan' },
  { value: 'BS', label: 'Bahamas' },
  { value: 'BH', label: 'Bahrain' },
  { value: 'BD', label: 'Bangladesh' },
  { value: 'BB', label: 'Barbados' },
  { value: 'BY', label: 'Belarus' },
  { value: 'BE', label: 'Belgium' },
  { value: 'BZ', label: 'Belize' },
  { value: 'BJ', label: 'Benin' },
  { value: 'BM', label: 'Bermuda' },
  { value: 'BT', label: 'Bhutan' },
  { value: 'BO', label: 'Bolivia' },
  { value: 'BA', label: 'Bosnia and Herzegovina' },
  { value: 'BW', label: 'Botswana' },
  { value: 'BV', label: 'Bouvet Island' },
  { value: 'BR', label: 'Brazil' },
  { value: 'IO', label: 'British Indian Ocean Territory' },
  { value: 'BN', label: 'Brunei Darussalam' },
  { value: 'BG', label: 'Bulgaria' },
  { value: 'BF', label: 'Burkina Faso' },
  { value: 'BI', label: 'Burundi' },
  { value: 'CV', label: 'Cabo Verde' },
  { value: 'KH', label: 'Cambodia' },
  { value: 'CM', label: 'Cameroon' },
  { value: 'CA', label: 'Canada' },
  { value: 'KY', label: 'Cayman Islands' },
  { value: 'CF', label: 'Central African Republic' },
  { value: 'TD', label: 'Chad' },
  { value: 'CL', label: 'Chile' },
  { value: 'CN', label: 'China' },
  { value: 'CX', label: 'Christmas Island' },
  { value: 'CC', label: 'Cocos (Keeling) Islands' },
  { value: 'CO', label: 'Colombia' },
  { value: 'KM', label: 'Comoros' },
  { value: 'CG', label: 'Congo' },
  { value: 'CD', label: 'Congo, Democratic Republic of the' },
  { value: 'CK', label: 'Cook Islands' },
  { value: 'CR', label: 'Costa Rica' },
  { value: 'HR', label: 'Croatia' },
  { value: 'CU', label: 'Cuba' },
  { value: 'CW', label: 'Curaçao' },
  { value: 'CY', label: 'Cyprus' },
  { value: 'CZ', label: 'Czech Republic' },
  { value: 'DK', label: 'Denmark' },
  { value: 'DJ', label: 'Djibouti' },
  { value: 'DM', label: 'Dominica' },
  { value: 'DO', label: 'Dominican Republic' },
  { value: 'EC', label: 'Ecuador' },
  { value: 'EG', label: 'Egypt' },
  { value: 'SV', label: 'El Salvador' },
  { value: 'GQ', label: 'Equatorial Guinea' },
  { value: 'ER', label: 'Eritrea' },
  { value: 'EE', label: 'Estonia' },
  { value: 'SZ', label: 'Eswatini' },
  { value: 'ET', label: 'Ethiopia' },
  { value: 'FK', label: 'Falkland Islands (Malvinas)' },
  { value: 'FO', label: 'Faroe Islands' },
  { value: 'FJ', label: 'Fiji' },
  { value: 'FI', label: 'Finland' },
  { value: 'FR', label: 'France' },
  { value: 'GF', label: 'French Guiana' },
  { value: 'PF', label: 'French Polynesia' },
  { value: 'TF', label: 'French Southern Territories' },
  { value: 'GA', label: 'Gabon' },
  { value: 'GM', label: 'Gambia' },
  { value: 'GE', label: 'Georgia' },
  { value: 'DE', label: 'Germany' },
  { value: 'GH', label: 'Ghana' },
  { value: 'GI', label: 'Gibraltar' },
  { value: 'GR', label: 'Greece' },
  { value: 'GL', label: 'Greenland' },
  { value: 'GD', label: 'Grenada' },
  { value: 'GP', label: 'Guadeloupe' },
  { value: 'GU', label: 'Guam' },
  { value: 'GT', label: 'Guatemala' },
  { value: 'GG', label: 'Guernsey' },
  { value: 'GN', label: 'Guinea' },
  { value: 'GW', label: 'Guinea-Bissau' },
  { value: 'GY', label: 'Guyana' },
  { value: 'HT', label: 'Haiti' },
  { value: 'HM', label: 'Heard Island and McDonald Islands' },
  { value: 'VA', label: 'Holy See' },
  { value: 'HN', label: 'Honduras' },
  { value: 'HK', label: 'Hong Kong' },
  { value: 'HU', label: 'Hungary' },
  { value: 'IS', label: 'Iceland' },
  { value: 'IN', label: 'India' },
  { value: 'ID', label: 'Indonesia' },
  { value: 'IR', label: 'Iran' },
  { value: 'IQ', label: 'Iraq' },
  { value: 'IE', label: 'Ireland' },
  { value: 'IM', label: 'Isle of Man' },
  { value: 'IL', label: 'Israel' },
  { value: 'IT', label: 'Italy' },
  { value: 'JM', label: 'Jamaica' },
  { value: 'JP', label: 'Japan' },
  { value: 'JE', label: 'Jersey' },
  { value: 'JO', label: 'Jordan' },
  { value: 'KZ', label: 'Kazakhstan' },
  { value: 'KE', label: 'Kenya' },
  { value: 'KI', label: 'Kiribati' },
  { value: 'KP', label: 'Korea (North)' },
  { value: 'KR', label: 'Korea (South)' },
  { value: 'KW', label: 'Kuwait' },
  { value: 'KG', label: 'Kyrgyzstan' },
  { value: 'LA', label: 'Laos' },
  { value: 'LV', label: 'Latvia' },
  { value: 'LB', label: 'Lebanon' },
  { value: 'LS', label: 'Lesotho' },
  { value: 'LR', label: 'Liberia' },
  { value: 'LY', label: 'Libya' },
  { value: 'LI', label: 'Liechtenstein' },
  { value: 'LT', label: 'Lithuania' },
  { value: 'LU', label: 'Luxembourg' },
  { value: 'MO', label: 'Macao' },
  { value: 'MG', label: 'Madagascar' },
  { value: 'MW', label: 'Malawi' },
  { value: 'MY', label: 'Malaysia' },
  { value: 'MV', label: 'Maldives' },
  { value: 'ML', label: 'Mali' },
  { value: 'MT', label: 'Malta' },
  { value: 'MH', label: 'Marshall Islands' },
  { value: 'MQ', label: 'Martinique' },
  { value: 'MR', label: 'Mauritania' },
  { value: 'MU', label: 'Mauritius' },
  { value: 'YT', label: 'Mayotte' },
  { value: 'MX', label: 'Mexico' },
  { value: 'FM', label: 'Micronesia (Federated States of)' },
  { value: 'MD', label: 'Moldova' },
  { value: 'MC', label: 'Monaco' },
  { value: 'MN', label: 'Mongolia' },
  { value: 'ME', label: 'Montenegro' },
  { value: 'MS', label: 'Montserrat' },
  { value: 'MA', label: 'Morocco' },
  { value: 'MZ', label: 'Mozambique' },
  { value: 'MM', label: 'Myanmar' },
  { value: 'NA', label: 'Namibia' },
  { value: 'NR', label: 'Nauru' },
  { value: 'NP', label: 'Nepal' },
  { value: 'NL', label: 'Netherlands' },
  { value: 'NC', label: 'New Caledonia' },
  { value: 'NZ', label: 'New Zealand' },
  { value: 'NI', label: 'Nicaragua' },
  { value: 'NE', label: 'Niger' },
  { value: 'NG', label: 'Nigeria' },
  { value: 'NU', label: 'Niue' },
  { value: 'NF', label: 'Norfolk Island' },
  { value: 'MK', label: 'North Macedonia' },
  { value: 'MP', label: 'Northern Mariana Islands' },
  { value: 'NO', label: 'Norway' },
  { value: 'OM', label: 'Oman' },
  { value: 'PK', label: 'Pakistan' },
  { value: 'PW', label: 'Palau' },
  { value: 'PS', label: 'Palestine, State of' },
  { value: 'PA', label: 'Panama' },
  { value: 'PG', label: 'Papua New Guinea' },
  { value: 'PY', label: 'Paraguay' },
  { value: 'PE', label: 'Peru' },
  { value: 'PH', label: 'Philippines' },
  { value: 'PN', label: 'Pitcairn' },
  { value: 'PL', label: 'Poland' },
  { value: 'PT', label: 'Portugal' },
  { value: 'PR', label: 'Puerto Rico' },
  { value: 'QA', label: 'Qatar' },
  { value: 'RE', label: 'Réunion' },
  { value: 'RO', label: 'Romania' },
  { value: 'RU', label: 'Russian Federation' },
  { value: 'RW', label: 'Rwanda' },
  { value: 'BL', label: 'Saint Barthélemy' },
  { value: 'SH', label: 'Saint Helena, Ascension and Tristan da Cunha' },
  { value: 'KN', label: 'Saint Kitts and Nevis' },
  { value: 'LC', label: 'Saint Lucia' },
  { value: 'MF', label: 'Saint Martin (French part)' },
  { value: 'PM', label: 'Saint Pierre and Miquelon' },
  { value: 'VC', label: 'Saint Vincent and the Grenadines' },
  { value: 'WS', label: 'Samoa' },
  { value: 'SM', label: 'San Marino' },
  { value: 'ST', label: 'Sao Tome and Principe' },
  { value: 'SA', label: 'Saudi Arabia' },
  { value: 'SN', label: 'Senegal' },
  { value: 'RS', label: 'Serbia' },
  { value: 'SC', label: 'Seychelles' },
  { value: 'SL', label: 'Sierra Leone' },
  { value: 'SG', label: 'Singapore' },
  { value: 'SX', label: 'Sint Maarten (Dutch part)' },
  { value: 'SK', label: 'Slovakia' },
  { value: 'SI', label: 'Slovenia' },
  { value: 'SB', label: 'Solomon Islands' },
  { value: 'SO', label: 'Somalia' },
  { value: 'ZA', label: 'South Africa' },
  { value: 'GS', label: 'South Georgia and the South Sandwich Islands' },
  { value: 'SS', label: 'South Sudan' },
  { value: 'ES', label: 'Spain' },
  { value: 'LK', label: 'Sri Lanka' },
  { value: 'SD', label: 'Sudan' },
  { value: 'SR', label: 'Suriname' },
  { value: 'SJ', label: 'Svalbard and Jan Mayen' },
  { value: 'SE', label: 'Sweden' },
  { value: 'CH', label: 'Switzerland' },
  { value: 'SY', label: 'Syrian Arab Republic' },
  { value: 'TW', label: 'Taiwan' },
  { value: 'TJ', label: 'Tajikistan' },
  { value: 'TZ', label: 'Tanzania' },
  { value: 'TH', label: 'Thailand' },
  { value: 'TL', label: 'Timor-Leste' },
  { value: 'TG', label: 'Togo' },
  { value: 'TK', label: 'Tokelau' },
  { value: 'TO', label: 'Tonga' },
  { value: 'TT', label: 'Trinidad and Tobago' },
  { value: 'TN', label: 'Tunisia' },
  { value: 'TR', label: 'Turkey' },
  { value: 'TM', label: 'Turkmenistan' },
  { value: 'TC', label: 'Turks and Caicos Islands' },
  { value: 'TV', label: 'Tuvalu' },
  { value: 'UG', label: 'Uganda' },
  { value: 'UA', label: 'Ukraine' },
  { value: 'AE', label: 'United Arab Emirates' },
  { value: 'GB', label: 'United Kingdom' },
  { value: 'US', label: 'United States of America' },
  { value: 'UY', label: 'Uruguay' },
  { value: 'UZ', label: 'Uzbekistan' },
  { value: 'VU', label: 'Vanuatu' },
  { value: 'VE', label: 'Venezuela' },
  { value: 'VN', label: 'Viet Nam' },
  { value: 'VG', label: 'Virgin Islands (British)' },
  { value: 'VI', label: 'Virgin Islands (U.S.)' },
  { value: 'WF', label: 'Wallis and Futuna' },
  { value: 'EH', label: 'Western Sahara' },
  { value: 'YE', label: 'Yemen' },
  { value: 'ZM', label: 'Zambia' },
  { value: 'ZW', label: 'Zimbabwe' },
];

const CurrencyOptions = [
  { value: 'AED', label: 'United Arab Emirates Dirham (AED)' },
  { value: 'AFN', label: 'Afghan Afghani (AFN)' },
  { value: 'ALL', label: 'Albanian Lek (ALL)' },
  { value: 'AMD', label: 'Armenian Dram (AMD)' },
  { value: 'ANG', label: 'Netherlands Antillean Guilder (ANG)' },
  { value: 'AOA', label: 'Angolan Kwanza (AOA)' },
  { value: 'ARS', label: 'Argentine Peso (ARS)' },
  { value: 'AUD', label: 'Australian Dollar (AUD)' },
  { value: 'AWG', label: 'Aruban Florin (AWG)' },
  { value: 'AZN', label: 'Azerbaijani Manat (AZN)' },
  { value: 'BAM', label: 'Bosnia-Herzegovina Convertible Mark (BAM)' },
  { value: 'BBD', label: 'Barbadian Dollar (BBD)' },
  { value: 'BDT', label: 'Bangladeshi Taka (BDT)' },
  { value: 'BGN', label: 'Bulgarian Lev (BGN)' },
  { value: 'BHD', label: 'Bahraini Dinar (BHD)' },
  { value: 'BIF', label: 'Burundian Franc (BIF)' },
  { value: 'BMD', label: 'Bermudian Dollar (BMD)' },
  { value: 'BND', label: 'Brunei Dollar (BND)' },
  { value: 'BOB', label: 'Bolivian Boliviano (BOB)' },
  { value: 'BRL', label: 'Brazilian Real (BRL)' },
  { value: 'BSD', label: 'Bahamian Dollar (BSD)' },
  { value: 'BTN', label: 'Bhutanese Ngultrum (BTN)' },
  { value: 'BWP', label: 'Botswana Pula (BWP)' },
  { value: 'BYN', label: 'Belarusian Ruble (BYN)' },
  { value: 'BZD', label: 'Belize Dollar (BZD)' },
  { value: 'CAD', label: 'Canadian Dollar (CAD)' },
  { value: 'CDF', label: 'Congolese Franc (CDF)' },
  { value: 'CHF', label: 'Swiss Franc (CHF)' },
  { value: 'CLP', label: 'Chilean Peso (CLP)' },
  { value: 'CNY', label: 'Chinese Yuan (CNY)' },
  { value: 'COP', label: 'Colombian Peso (COP)' },
  { value: 'CRC', label: 'Costa Rican Colón (CRC)' },
  { value: 'CUP', label: 'Cuban Peso (CUP)' },
  { value: 'CVE', label: 'Cape Verdean Escudo (CVE)' },
  { value: 'CZK', label: 'Czech Koruna (CZK)' },
  { value: 'DJF', label: 'Djiboutian Franc (DJF)' },
  { value: 'DKK', label: 'Danish Krone (DKK)' },
  { value: 'DOP', label: 'Dominican Peso (DOP)' },
  { value: 'DZD', label: 'Algerian Dinar (DZD)' },
  { value: 'EGP', label: 'Egyptian Pound (EGP)' },
  { value: 'ERN', label: 'Eritrean Nakfa (ERN)' },
  { value: 'ETB', label: 'Ethiopian Birr (ETB)' },
  { value: 'EUR', label: 'Euro (EUR)' },
  { value: 'FJD', label: 'Fijian Dollar (FJD)' },
  { value: 'FKP', label: 'Falkland Islands Pound (FKP)' },
  { value: 'FOK', label: 'Faroese Króna (FOK)' },
  { value: 'GBP', label: 'British Pound (GBP)' },
  { value: 'GEL', label: 'Georgian Lari (GEL)' },
  { value: 'GGP', label: 'Guernsey Pound (GGP)' },
  { value: 'GHS', label: 'Ghanaian Cedi (GHS)' },
  { value: 'GIP', label: 'Gibraltar Pound (GIP)' },
  { value: 'GMD', label: 'Gambian Dalasi (GMD)' },
  { value: 'GNF', label: 'Guinean Franc (GNF)' },
  { value: 'GTQ', label: 'Guatemalan Quetzal (GTQ)' },
  { value: 'GYD', label: 'Guyanese Dollar (GYD)' },
  { value: 'HKD', label: 'Hong Kong Dollar (HKD)' },
  { value: 'HNL', label: 'Honduran Lempira (HNL)' },
  { value: 'HRK', label: 'Croatian Kuna (HRK)' },
  { value: 'HTG', label: 'Haitian Gourde (HTG)' },
  { value: 'HUF', label: 'Hungarian Forint (HUF)' },
  { value: 'IDR', label: 'Indonesian Rupiah (IDR)' },
  { value: 'ILS', label: 'Israeli New Shekel (ILS)' },
  { value: 'IMP', label: 'Isle of Man Pound (IMP)' },
  { value: 'INR', label: 'Indian Rupee (INR)' },
  { value: 'IQD', label: 'Iraqi Dinar (IQD)' },
  { value: 'IRR', label: 'Iranian Rial (IRR)' },
  { value: 'ISK', label: 'Icelandic Króna (ISK)' },
  { value: 'JEP', label: 'Jersey Pound (JEP)' },
  { value: 'JMD', label: 'Jamaican Dollar (JMD)' },
  { value: 'JOD', label: 'Jordanian Dinar (JOD)' },
  { value: 'JPY', label: 'Japanese Yen (JPY)' },
  { value: 'KES', label: 'Kenyan Shilling (KES)' },
  { value: 'KGS', label: 'Kyrgyzstani Som (KGS)' },
  { value: 'KHR', label: 'Cambodian Riel (KHR)' },
  { value: 'KID', label: 'Kiribati Dollar (KID)' },
  { value: 'KMF', label: 'Comorian Franc (KMF)' },
  { value: 'KRW', label: 'South Korean Won (KRW)' },
  { value: 'KWD', label: 'Kuwaiti Dinar (KWD)' },
  { value: 'KYD', label: 'Cayman Islands Dollar (KYD)' },
  { value: 'KZT', label: 'Kazakhstani Tenge (KZT)' },
  { value: 'LAK', label: 'Lao Kip (LAK)' },
  { value: 'LBP', label: 'Lebanese Pound (LBP)' },
  { value: 'LKR', label: 'Sri Lankan Rupee (LKR)' },
  { value: 'LRD', label: 'Liberian Dollar (LRD)' },
  { value: 'LSL', label: 'Lesotho Loti (LSL)' },
  { value: 'LYD', label: 'Libyan Dinar (LYD)' },
  { value: 'MAD', label: 'Moroccan Dirham (MAD)' },
  { value: 'MDL', label: 'Moldovan Leu (MDL)' },
  { value: 'MGA', label: 'Malagasy Ariary (MGA)' },
  { value: 'MKD', label: 'Macedonian Denar (MKD)' },
  { value: 'MMK', label: 'Burmese Kyat (MMK)' },
  { value: 'MNT', label: 'Mongolian Tögrög (MNT)' },
  { value: 'MOP', label: 'Macanese Pataca (MOP)' },
  { value: 'MRU', label: 'Mauritanian Ouguiya (MRU)' },
  { value: 'MUR', label: 'Mauritian Rupee (MUR)' },
  { value: 'MVR', label: 'Maldivian Rufiyaa (MVR)' },
  { value: 'MWK', label: 'Malawian Kwacha (MWK)' },
  { value: 'MXN', label: 'Mexican Peso (MXN)' },
  { value: 'MYR', label: 'Malaysian Ringgit (MYR)' },
  { value: 'MZN', label: 'Mozambican Metical (MZN)' },
  { value: 'NAD', label: 'Namibian Dollar (NAD)' },
  { value: 'NGN', label: 'Nigerian Naira (NGN)' },
  { value: 'NIO', label: 'Nicaraguan Córdoba (NIO)' },
  { value: 'NOK', label: 'Norwegian Krone (NOK)' },
  { value: 'NPR', label: 'Nepalese Rupee (NPR)' },
  { value: 'NZD', label: 'New Zealand Dollar (NZD)' },
  { value: 'OMR', label: 'Omani Rial (OMR)' },
  { value: 'PAB', label: 'Panamanian Balboa (PAB)' },
  { value: 'PEN', label: 'Peruvian Sol (PEN)' },
  { value: 'PGK', label: 'Papua New Guinean Kina (PGK)' },
  { value: 'PHP', label: 'Philippine Peso (PHP)' },
  { value: 'PKR', label: 'Pakistani Rupee (PKR)' },
  { value: 'PLN', label: 'Polish Złoty (PLN)' },
  { value: 'PYG', label: 'Paraguayan Guaraní (PYG)' },
  { value: 'QAR', label: 'Qatari Riyal (QAR)' },
  { value: 'RON', label: 'Romanian Leu (RON)' },
  { value: 'RSD', label: 'Serbian Dinar (RSD)' },
  { value: 'RUB', label: 'Russian Ruble (RUB)' },
  { value: 'RWF', label: 'Rwandan Franc (RWF)' },
  { value: 'SAR', label: 'Saudi Riyal (SAR)' },
  { value: 'SBD', label: 'Solomon Islands Dollar (SBD)' },
  { value: 'SCR', label: 'Seychellois Rupee (SCR)' },
  { value: 'SDG', label: 'Sudanese Pound (SDG)' },
  { value: 'SEK', label: 'Swedish Krona (SEK)' },
  { value: 'SGD', label: 'Singapore Dollar (SGD)' },
  { value: 'SHP', label: 'Saint Helena Pound (SHP)' },
  { value: 'SLL', label: 'Sierra Leonean Leone (SLL)' },
  { value: 'SOS', label: 'Somali Shilling (SOS)' },
  { value: 'SRD', label: 'Surinamese Dollar (SRD)' },
  { value: 'SSP', label: 'South Sudanese Pound (SSP)' },
  { value: 'STN', label: 'São Tomé and Príncipe Dobra (STN)' },
  { value: 'SYP', label: 'Syrian Pound (SYP)' },
  { value: 'SZL', label: 'Eswatini Lilangeni (SZL)' },
  { value: 'THB', label: 'Thai Baht (THB)' },
  { value: 'TJS', label: 'Tajikistani Somoni (TJS)' },
  { value: 'TMT', label: 'Turkmenistani Manat (TMT)' },
  { value: 'TND', label: 'Tunisian Dinar (TND)' },
  { value: 'TOP', label: 'Tongan Paʻanga (TOP)' },
  { value: 'TRY', label: 'Turkish Lira (TRY)' },
  { value: 'TTD', label: 'Trinidad and Tobago Dollar (TTD)' },
  { value: 'TVD', label: 'Tuvaluan Dollar (TVD)' },
  { value: 'TWD', label: 'New Taiwan Dollar (TWD)' },
  { value: 'TZS', label: 'Tanzanian Shilling (TZS)' },
  { value: 'UAH', label: 'Ukrainian Hryvnia (UAH)' },
  { value: 'UGX', label: 'Ugandan Shilling (UGX)' },
  { value: 'USD', label: 'United States Dollar (USD)' },
  { value: 'UYU', label: 'Uruguayan Peso (UYU)' },
  { value: 'UZS', label: 'Uzbekistani Som (UZS)' },
  { value: 'VES', label: 'Venezuelan Bolívar Soberano (VES)' },
  { value: 'VND', label: 'Vietnamese Đồng (VND)' },
  { value: 'VUV', label: 'Vanuatu Vatu (VUV)' },
  { value: 'WST', label: 'Samoan Tālā (WST)' },
  { value: 'XAF', label: 'Central African CFA Franc (XAF)' },
  { value: 'XCD', label: 'East Caribbean Dollar (XCD)' },
  { value: 'XDR', label: 'Special Drawing Rights (XDR)' },
  { value: 'XOF', label: 'West African CFA Franc (XOF)' },
  { value: 'XPF', label: 'CFP Franc (XPF)' },
  { value: 'YER', label: 'Yemeni Rial (YER)' },
  { value: 'ZAR', label: 'South African Rand (ZAR)' },
  { value: 'ZMW', label: 'Zambian Kwacha (ZMW)' },
  { value: 'ZWL', label: 'Zimbabwean Dollar (ZWL)' },
];

const MandatoryFields = ['State', 'Address', 'City', 'ZipCode', 'CompanyName', 'Country', 'selectedFields', 'Companytype', 'allocation_vendor_name'];

const fieldMapping: { [key: string]: string } = {
  CompanyName: "Company Name",
  Website: "Web site",
  Groups: "Groups",
  MobileNo: "Mobile No",
  Address: "Address",
  Companytype: 'Company Type',
  selectedFields: 'Selected Fields',
  Currency: "Currency",
  ZipCode: "Zip Code",
  State: "State",
  City: "City",
  Providers: "Providers",
  Group: "Group",
  Country: "Country",
  allocation_vendor_name: "Map Vendor",
  FirstName: "First Name",
  LastName: "Last Name",
  Position: "Position",
  Email: "Email",
  Phone: "Phone",
  Direction: "Direction",
  UserName: "User Name",
  Password: "Password",
  Insurance: "Insurance",
};

interface VendorOption {
  label: string;
  value: string;
}

const Addclientadmin: React.FC = () => {
  const customCheckboxStyle = `
    .custom-checkbox {
      appearance: none;
      -webkit-appearance: none;
      -moz-appearance: none;
      width: 20px !important;
      height: 20px !important;
      border: 2px solid #1f33e4 !important;
      border-radius: 4px !important;
      background-color: transparent;
      display: inline-block;
      position: relative;
      cursor: pointer;
      vertical-align: middle;
      transition: all 0.2s ease;  
    }
    .custom-checkbox:checked {
      background-color: #1f33e4 !important;
    }
    .custom-checkbox:checked::after {
      content: '';
      position: absolute;
      left: 5px;
      top: 1px;
      width: 6px;
      height: 12px;
      border: solid white;
      border-width: 0 2px 2px 0;
      transform: rotate(45deg);
    }
  `;
  const dispatch = useAppDispatch()
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [companyType, setCompanyType] = useState<string[]>([]);
  const [vendorOptions, setVendorOptions] = useState<VendorOption[]>([]);
  const [insuranceoption, setInsurance] = useState<Iinsuranceoption[]>([]);
  const [SelectedInsurancename, setSelectedInsurance] = useState<string>('');
  const [SelectedInsuranceId, setSelectedInsuranceId] = useState<string>('');
  const [decryptedTemplateData, setDecryptedTemplateData] = useState<any[]>([]);
  const [expandedSections, setExpandedSections] = useState<Record<string, boolean>>({});
  const [mainExpandedSections, setMainExpandedSections] = useState<Record<string, boolean>>({
    clientDetails: true,
    insurance: true,
    contactDetails: true,
    systemPrompt: true,
    questionsAndInstructions: true
  });

  const toggleMainSection = (section: string) => {
    setMainExpandedSections(prev => ({ ...prev, [section]: !prev[section] }));
  };

  // Changed state to handle only one visible password at a time
  const [showPasswordIndex, setShowPasswordIndex] = useState<number | null>(null);
  const [searchTerm, setSearchTerm] = useState<string>('');

  const UserType = localStorage.UserType
  const canEditLink = UserType === 'MOS' || UserType === 'Client';

  // Insurance rows whose portal link has been unlocked for editing
  const [editableLinkIndexes, setEditableLinkIndexes] = useState<number[]>([]);

  const handleLinkEditToggle = (index: number) => {
    if (editableLinkIndexes.includes(index)) {
      setEditableLinkIndexes(prev => prev.filter(i => i !== index));
      return;
    }
    Swal.fire({
      title: 'Change Portal Link?',
      text: 'Are you sure you want to change the portal link?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, change it',
      cancelButtonText: 'Cancel',
    }).then((result) => {
      if (result.isConfirmed) {
        setEditableLinkIndexes(prev => [...prev, index]);
      }
    });
  };

  // Keep unlocked link indexes in sync when an insurance row is removed
  const shiftEditableLinkIndexes = (removedIndex: number) => {
    setEditableLinkIndexes(prev => prev.filter(i => i !== removedIndex).map(i => (i > removedIndex ? i - 1 : i)));
  };

  useEffect(() => {
    dispatch(get_vendorname())
      .then((response) => {
        const res1 = response.payload;
        const vendorname = res1.map((item: any) => ({
          label: item.CompanyName,
          value: item.id,
        }));
        const vendor = vendorname.slice().sort((a: any, b: any) =>
          a.label.localeCompare(b.label)
        );
        setVendorOptions(vendor);
      })
      .catch((error) => {
        console.error(error);
      });
  }, [dispatch]);


  const CreateClient = async (data: any) => {
    const Refid = uuidv4();
    const key = await keyPromise
    const params = data.params
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || localStorage.getItem('timezone') || '';
    const Data = { params, Refid, timezone };
    const EncParams = await AesEncrypt(key, Data);
    const ref = await api.fetch('api/ClientManagement/AddClient', {
      method: 'POST',
      body: JSON.stringify({ EncParams })
    }).then(response => response.json());
    return await AesDecrypt(key, ref);
  };

  const AddAuditLogData = async (data: any) => {
    const key = await keyPromise
    data.Userid = localStorage.id;
    const ID = data.Refid;
    const EncParams = await AesEncrypt(key, { Data: data, ID });
    const ref = await api.fetch('api/ClientManagement/AddAuditLogData', {
      method: 'POST',
      body: JSON.stringify({ EncParams })
    }).then(response => response.json());
    return (ref);
  };


  const get_Insurance = async () => {
    const key = await keyPromise; // Get the key
    const response = await api.fetch('api/ClientManagement/insurancename', {
      method: 'POST'
    }).then((response) => response.json());

    const TempData = AesDecrypt(key, response);
    return TempData;
  };

  useEffect(() => {
    const fetchRoleId = async () => {
      const response = await get_Insurance();
      const res = response.map((data: any) => ({
        link: data.link,
        label: data.name,
        value: data.id,
        SoftwareName: data.SoftwareName,
        bot_status: data.bot_status,
      }));
      setInsurance(res);
    };
    // Fetch the initial data
    fetchRoleId();
  }, []);

  const UserId = localStorage.id;
  useEffect(() => {
    const fetchData = async () => {
      const key = await keyPromise
      const EncParams = await AesEncrypt(key, UserId);
      try {
        const response = await api.fetch("api/TemplateCreation/get_patient_details", {
          method: 'POST',
          body: JSON.stringify({ EncParams }),
        });
        if (!response.ok) {
          throw new Error('Failed to fetch data');
        }
        const result = await response.json();
        const decryptedResult = await AesDecrypt(key, result);

        if (decryptedResult.message === 'There is no Record Found') {
          setDecryptedTemplateData([]);
        } else {
          setDecryptedTemplateData(Object.entries(decryptedResult[0]));
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    // Initial fetch of patient data
    fetchData();
    // WebSocket setup
    const socket = new WebSocket(`${websocket_webservice}ws/Tempalatedata/`);
    socket.onmessage = () => {
      fetchData();
    };
    // Clean up the WebSocket connection when the component unmounts
    return () => {
      if (socket.readyState === 1) {
        socket.close();
      }
    }
  }, []);

  const toggleSection = (section: string) => {
    setExpandedSections((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };


  const handleinsuranceChange = (
    selectedOption: SingleValue<Iinsuranceoption>,
    setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void,
    index: number
  ) => {
    if (selectedOption) {
      setSelectedInsurance(selectedOption.label);
      setSelectedInsuranceId(selectedOption.value);
      setFieldValue(`Insurance[${index}].name`, selectedOption.label); // Set name in Formik
      setFieldValue(`Insurance[${index}].link`, selectedOption.link || ''); // Set link from Portal_Link
      setFieldValue(`Insurance[${index}].SoftwareName`, selectedOption.SoftwareName || false);
      setFieldValue(`Insurance[${index}].bot_status`, selectedOption.bot_status || '');

    } else {
      setSelectedInsurance('');
      setSelectedInsuranceId('');
      setFieldValue(`Insurance[${index}].name`, ''); // Clear name in Formik
      setFieldValue(`Insurance[${index}].link`, ''); // Clear link in Formik
      setFieldValue(`Insurance[${index}].SoftwareName`, false);
      setFieldValue(`Insurance[${index}].bot_status`, '');
    }
  };

  // --------------------------------------------prompt section------------------------------------------------
  const [mappingPrompts, setMappingPrompts] = useState<Prompt[]>([{ id: 1, text: "" }]);
  const [systemPrompt, setSystemPrompt] = useState<string>(""); // Added systemPrompt state

  // === Fetch existing prompts on mount ===
  useEffect(() => {
    const fetchPrompts = async () => {
      try {
        const response = await api.fetch('api/prompt/get-prompts-data', { method: 'GET' }).then((response) => response.json());

        const data = response; // data is already parsed json
        if (data && data.system_prompt) {
          setSystemPrompt(data.system_prompt);
        }
        // const processPrompts = (items: any, keyName: any) => {
        //   return items.flatMap((item: any) =>
        //     Object.entries(item[keyName] || {}).map(([key, value]) => {
        //       const match = key.match(/_(\d+)$/);
        //       return {
        //         id: match ? Number(match[1]) : key,
        //         text: value || ""
        //       };
        //     })
        //   );
        // };

        // // === Mapping Prompts ===
        // const mapping = processPrompts(data, "mappingPrompts");
        // setMappingPrompts(mapping.length > 0 ? mapping : [{ id: 1, text: "" }]);

      } catch (error) {
        console.error("Error fetching prompts:", error);
      }
    };

    fetchPrompts();
  }, []);


  // === Add Prompt ===
  const handleAddPrompt = (
    setPrompts: React.Dispatch<React.SetStateAction<Prompt[]>>,
    prompts: Prompt[]
  ) => {
    const newId = prompts.length ? Math.max(...prompts.map(p => p.id)) + 1 : 1;
    setPrompts([...prompts, { id: newId, text: "" }]);
  };

  // === Remove Prompt ===
  const handleRemovePrompt = (
    setPrompts: React.Dispatch<React.SetStateAction<Prompt[]>>,
    prompts: Prompt[],
    id: number
  ) => {
    setPrompts(prompts.filter((p) => p.id !== id));
  };

  // === Handle Input Change ===
  const handleChangePrompt = (
    setPrompts: React.Dispatch<React.SetStateAction<Prompt[]>>,
    prompts: Prompt[],
    id: number,
    newText: string
  ) => {
    const updated = prompts.map((p) =>
      p.id === id ? { ...p, text: newText } : p
    );
    setPrompts(updated);
  };

  // === Transform for Save ===
  const transformPrompts = (
    prompts: Prompt[],
    baseLabel: string
  ): Record<string, string> => {
    const result: Record<string, string> = {};
    prompts.forEach((p, i) => {
      result[`${baseLabel}_${i + 1}`] = p.text;
    });
    return result;
  };

  // === Render Prompt Section ===
  const renderPromptSection = (
    label: string,
    prompts: Prompt[],
    setPrompts: React.Dispatch<React.SetStateAction<Prompt[]>>,
    tooltipContent: string,
    tooltipId: string
  ) => (
    <div className="prompt-section">
      <div className="prompt_tittle-header d-flex align-items-center justify-content-between">
        <h3>{label}</h3>
        <div id={tooltipId} className="promptadd-icon" title={tooltipContent}>
          <Info style={{ color: "#0080ff", cursor: "pointer" }} />
        </div>
      </div>
      <CardBody>
        <Row>
          <Col md={10}>
            {prompts.map((prompt, index) => (
              <div key={prompt.id} className="d-flex align-items-center mb-2">
                <FormGroup className="flex-grow-1 mb-0">
                  <Label for={`prompt-${prompt.id}`}>
                    {prompts.length > 1
                      ? `${label} ${index + 1}`
                      : label}
                  </Label>
                  <Input
                    type="textarea"
                    className="textpromptmaster"
                    id={`prompt-${prompt.id}`}
                    value={prompt.text}
                    onChange={(e) =>
                      handleChangePrompt(
                        setPrompts,
                        prompts,
                        prompt.id,
                        e.target.value
                      )
                    }
                  />
                </FormGroup>
                &nbsp;&nbsp;&nbsp;
                {prompts.length > 1 && (
                  <Button
                    color="danger"
                    onClick={() =>
                      handleRemovePrompt(setPrompts, prompts, prompt.id)
                    }
                    className="circle-button"
                  >
                    X
                  </Button>
                )}
              </div>
            ))}
          </Col>
          <Col md={2} className="text-right">
            <Button
              color="primary"
              onClick={() => handleAddPrompt(setPrompts, prompts)}
              className="circle-button"
              style={{ marginTop: "24%" }}
            >
              <Plus size={10} />
            </Button>
          </Col>
        </Row>
      </CardBody>
    </div>
  );

  // System Prompt Section
  const renderSystemPromptSection = () => (
    <div className="prompt-section mt-4">
      <CardBody>
        <Row>
          <Col md={12}>
            <FormGroup>
              <Label>System Prompt</Label>
              <Input
                type="textarea"
                rows={5}
                value={systemPrompt}
                onChange={(e) => setSystemPrompt(e.target.value)}
              />
            </FormGroup>
          </Col>
        </Row>
      </CardBody>
    </div>
  );
  // -- --------------------------------------------end of prompt section------------------------------------------------

  const promptsData = {
    mappingPrompts: transformPrompts(mappingPrompts, "MappingPrompt"),
  };

  const handleSubmit = async (data: FormValues) => {
    const mapvendorValues = data.allocation_vendor_name.map((option: any) => option.label);

    const allocation_vendor_id = data.allocation_vendor_name.map((option: any) => option.value);

    data.allocation_vendor_name = mapvendorValues
    data.promptsData = promptsData
    data.system_prompt = systemPrompt;

    // Build a map of fieldName → preset instruction from API data (used as fallback)
    const apiInstructionMap: Record<string, string> = {};
    decryptedTemplateData.forEach(([, sectionValue]: [string, any]) => {
      const sectionFields = Array.isArray(sectionValue) ? sectionValue : Object.values(sectionValue);
      sectionFields.forEach((field: any) => {
        if (typeof field === 'object' && field.field_name) {
          apiInstructionMap[field.field_name] = field.instruction || '';
        }
      });
    });

    // Build structured selectedFields with instructions per section (don't mutate Formik values)
    const structuredSelectedFields: Record<string, { field_name: string; instruction: string }[]> = {};
    decryptedTemplateData.forEach(([sectionKey, sectionValue]: [string, any]) => {
      const sectionFields = Array.isArray(sectionValue) ? sectionValue : Object.values(sectionValue);
      const sectionFieldNames = sectionFields.map((field: any) => typeof field === 'object' ? field.field_name : field);
      const selectedInSection = sectionFieldNames.filter((name: string) => data.selectedFields.includes(name));
      if (selectedInSection.length > 0) {
        structuredSelectedFields[sectionKey] = selectedInSection.map((name: string) => ({
          field_name: name,
          // Use the user-typed instruction first, then fall back to the API preset instruction
          instruction: data.fieldInstructions?.[name] || apiInstructionMap[name] || ''
        }));
      }
    });

    // Create a submission copy so we don't mutate Formik's values
    const submitData: any = { ...data, selectedFields: structuredSelectedFields };
    delete submitData.fieldInstructions;

    if (isSubmitting) return;
    setIsSubmitting(true);
    const RequiredData: { [key: string]: string | undefined } = {};
    MandatoryFields.forEach((item) => {
      RequiredData[item] = (data as any)[item];
    });

    if (Object.values(RequiredData).every(field => field && field.length > 0)) {
      const getDataValue = (field: keyof FormValues) => {
        const val = data[field];
        if (val === undefined || val === null) {
          return '';
        }
        if (Array.isArray(val)) {
          if (field === 'Insurance') {
            return val.filter((item: any) => item.name && item.name !== "");
          }
          if (field === 'Group' || field === 'Providers') {
            return val.filter((item: any) => item.providerId && item.providerId !== "");
          }
          return val;
        }
        return (val as any).value || val;
      };

      const hasValue = (val: any, fieldName: string): boolean => {
        if (val === null || val === undefined || val === "") return false;
        if (Array.isArray(val)) {
          if (val.length === 0) return false;
          return val.some((item: any) => {
            if (typeof item === 'object' && item !== null) {
              if (fieldName === 'Insurance') return !!(item.name && item.name !== "");
              if (fieldName === 'Group' || fieldName === 'Providers') return !!(item.providerId && item.providerId !== "");
              return Object.entries(item).some(([k, v]) => k !== 'status' && v !== "" && v !== null && v !== undefined);
            }
            return item !== "" && item !== null && item !== undefined;
          });
        }
        if (typeof val === 'object' && val !== null) {
          return Object.entries(val).some(([k, v]) => v !== "" && v !== null && v !== undefined);
        }
        return true;
      };

      const auditLogData = Object.entries(data)
        .filter(([field, value]) => {
          if (field === "PayorUserIds" || field === "promptsData" || field === "allocation_vendor_id" || field === "allocation_vendor_name") return false;
          const isMandatory = MandatoryFields.includes(field);
          const enteredValue = hasValue(value, field);
          return isMandatory || enteredValue;
        })
        .map(([field, value]) => {
          const item = {
            field: fieldMapping[field] || field,
            value: getDataValue(field as keyof FormValues),
          };

          return item;
        })
      if (allocation_vendor_id) {
        submitData.allocation_vendor_id = allocation_vendor_id
      }

      const Data = { auditLogData, Username: localStorage.getItem('UserName') || '' };
      try {
        const ref = await CreateClient({ params: submitData });

        if (ref && ref.error) {
          setIsSubmitting(false);
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: ref.error,
          });
          return;
        }

        if (ref === 'Username is already taken.') {
          setIsSubmitting(false);
          Swal.fire({
            title: 'Warning',
            text: 'Username already exists.',
            icon: 'warning',
            customClass: {},
            showClass: {
              popup: 'animate__animated animate__shakeX',
            },
            buttonsStyling: true,
            allowOutsideClick: false,
          });
        } else if (ref === 'email is already taken.') {
          setIsSubmitting(false);
          Swal.fire({
            title: 'Warning',
            text: 'Email already exists.',
            icon: 'warning',
            customClass: {},
            showClass: {
              popup: 'animate__animated animate__shakeX',
            },
            buttonsStyling: true,
            allowOutsideClick: false,
          });
        } else if (ref === 'Username and email are already taken.') {
          setIsSubmitting(false);
          Swal.fire({
            title: 'Warning',
            text: 'Username and email already exist.',
            icon: 'warning',
            customClass: {},
            showClass: {
              popup: 'animate__animated animate__shakeX',
            },
            buttonsStyling: true,
            allowOutsideClick: false,
          });
        } else {
          if (ref !== 'Username and email are already taken.' && ref !== 'Username is already taken.'
            && ref !== 'email is already taken.') {
            const response = await AddAuditLogData({ ...Data, Refid: ref.RefId })
            if (response === 'Added Successfully') {
              navigate(`/clientManagement/addClient/${ref.ClientId}`);
            }
          }
        }
      } catch (error) {
        console.error('Error adding client:', error);
      }
      finally {
        setIsSubmitting(false);
      }
    } else {
      // Handle missing required fields
      setIsSubmitting(false);
      console.warn('Missing required fields:', RequiredData);
      const missingFields = Object.entries(RequiredData)
        .filter(([_, value]) => !value || (Array.isArray(value) && value.length === 0))
        .map(([key]) => fieldMapping[key] || key);

      Swal.fire({
        icon: 'warning',
        title: 'Missing Required Fields',
        text: `Please fill in the following mandatory fields: ${missingFields.join(', ')}`,
      });
    }
  };

  const ProviderSchema = Yup.object().shape({
    firstName: Yup.string().matches(/^[A-Za-z]+$/, "First Name should only contain letters").required('First Name is required'),

    lastName: Yup.string().required('Last Name is required'),
    providerId: Yup.string().required('Provider ID is required'),
  });


  const GroupSchema = Yup.object().shape({
    providerId: Yup.string().required('Provider ID is required'),
  });

  const FORM_VALIDATION = Yup.object().shape({

    CompanyName: Yup.string().required("Company Name is required"),
    Address: Yup.array().of(Yup.string().required("Address is required")),
    Companytype: Yup.array().of(Yup.string()).required("Companytype is required"),
    City: Yup.string().required("City is required"),
    State: Yup.string().matches(/^[A-Za-z]+$/, "State must contain only letters").required("State is required"),
    // Phone: Yup.string().matches(/^[0-9]+$/, "Phone number must contain only numbers").required("Phone number is required"),
    ZipCode: Yup.string().required("Zip Code is required"),
    Country: Yup.string().oneOf(CountryOptions.map(option => option.value), "Please select a valid Status").required("Please select a valid Status"),
    allocation_vendor_name: Yup.array()
      .of(
        Yup.object().shape({
          value: Yup.string().required(),
          label: Yup.string().required()
        })
      )
      .required("Please select at least one Vendor")
      .min(1, "Please select at least one Vendor"),
    selectedFields: Yup.array().min(1, "Please select at least one field").required("Please select at least one field"),
  });


  const handleNumbers = (event: any) => {
    event.target.value = event.target.value.replace(/[^0-9]/g, '');
  }
  const handleInput = (event: any) => {
    event.target.value = event.target.value.replace(/[^A-Za-z]/g, '');
  };


  const handleIndividualChange = (e: React.ChangeEvent<HTMLInputElement>, setFieldValue: any) => {
    const { checked } = e.target;
    let newCompanyType = [...companyType];

    if (checked) {
      // Add 'Individual' to the array
      if (!newCompanyType.includes('Individual')) {
        newCompanyType = [...newCompanyType, 'Individual'];
      }
    } else {
      // Remove 'Individual' from the array
      newCompanyType = newCompanyType.filter(type => type !== 'Individual');
    }

    setCompanyType(newCompanyType);
    setFieldValue('Companytype', newCompanyType);
  };

  const handleGroupChange = (e: React.ChangeEvent<HTMLInputElement>, setFieldValue: any) => {
    const { checked } = e.target;
    let newCompanyType = [...companyType];

    if (checked) {
      // Add 'Group' to the array
      if (!newCompanyType.includes('Group')) {
        newCompanyType = [...newCompanyType, 'Group'];
      }
    } else {
      // Remove 'Group' from the array
      newCompanyType = newCompanyType.filter(type => type !== 'Group');
    }

    setCompanyType(newCompanyType);
    setFieldValue('Companytype', newCompanyType);
  };

  return (
    <>
      <style>{customCheckboxStyle}</style>
      <Breadcrumbs mainTitle='Create Client' parent='Client Management' title='Add Client' to={`/client`} showBack={true} />
      <Fragment>
        <CardBody className='py-2 my-25'>
          <Formik initialValues={defaultValues} validationSchema={FORM_VALIDATION} onSubmit={handleSubmit}>
            {({ values, setFieldValue }) => (
              <Form className="form-horizontal">
                <Card className="shadow-sm mb-4">
                  <CardHeader
                    style={{
                      backgroundColor: '#B4B4B3',
                      cursor: 'pointer',
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      borderBottom: mainExpandedSections.clientDetails ? '1px solid #dee2e6' : 'none',
                      transition: 'all 0.3s ease'
                    }}
                    onClick={() => toggleMainSection('clientDetails')}
                    title={`Click to ${mainExpandedSections.clientDetails ? 'collapse' : 'expand'} Client Details`}
                  >
                    <CardTitle tag="h3" className="mb-0 d-flex align-items-center" style={{ color: '#333' }}>
                      {mainExpandedSections.clientDetails ? <ChevronDown size={20} className="me-2 text-primary" /> : <ChevronRight size={20} className="me-2 text-primary" />}
                      Client Details
                    </CardTitle>
                  </CardHeader>
                  {mainExpandedSections.clientDetails && (
                    <CardBody>
                      <Row>
                        <Col md={4} xs={12}>
                          <FormGroup>
                            <Label check> Company Name <span style={{ color: 'red' }}> * </span></Label>
                            <Field name="CompanyName" type="text" className="form-control" placeholder="Enter the Company Name" />
                            <ErrorMessage name="CompanyName" component="span" className="text-danger" />
                          </FormGroup>
                        </Col>
                        <Col md={4} xs={12}>
                          <FormGroup>
                            <Label check> Website </Label>
                            <Field name="Website" type="text" className="form-control" placeholder="Enter the Website" />
                            {/* <ErrorMessage name="Website" component="span" className="text-danger" /> */}
                          </FormGroup>
                        </Col>
                        <Col md={4} xs={12}>
                          <FormGroup>
                            <Label check>
                              Company Type <span style={{ color: 'red' }}> * </span>
                            </Label>
                            <Col md={6} xs={12}>
                              <Label check>
                                <input
                                  type="checkbox"
                                  name="Individual"
                                  value="Individual"
                                  checked={companyType.includes('Individual')}
                                  onChange={(e) => handleIndividualChange(e, setFieldValue)}
                                />
                                &nbsp;Individual
                              </Label>
                            </Col>
                            <ErrorMessage name="Companytype" component="span" className="text-danger" />
                            <Col md={3} xs={12}>
                              <Label check>
                                <input
                                  type="checkbox"
                                  name="Companytype"
                                  value="Group"
                                  checked={companyType.includes('Group')}
                                  onChange={(e) => handleGroupChange(e, setFieldValue)}
                                />
                                &nbsp;Group
                              </Label>
                            </Col>
                            <ErrorMessage name="Companytype" component="span" className="text-danger" />
                          </FormGroup>

                        </Col>
                        {companyType.includes('Individual') && (
                          <Col md="12">
                            <FieldArray name="Providers">
                              {({ push, remove }) => (
                                <div>
                                  <Label for="Providers">
                                    <strong>Individual Provider Details :</strong>
                                  </Label>
                                  <><br /></>
                                  {values.Providers.map((provider, index) => (
                                    <Row key={index} className="d-flex mb-3">
                                      <div className="d-flex">
                                        {/* Render First Name, Middle Name, Last Name, and Provider Tax Id fields only if companyType includes 'Individual' */}
                                        {companyType.includes('Individual') && (
                                          <>
                                            <Col md={2} xs={12} className="me-4">
                                              <Label check>
                                                First Name
                                              </Label>
                                              <Field
                                                name={`Providers[${index}].firstName`}
                                                type="text"
                                                onInput={handleInput}
                                                className="form-control"
                                                placeholder="First Name"
                                              />
                                              <ErrorMessage
                                                name={`Providers[${index}].firstName`}
                                                component="span"
                                                className="text-danger"
                                              />
                                            </Col>
                                            <Col md={2} xs={12} className="me-4">
                                              <Label check> Middle Name </Label>
                                              <Field
                                                name={`Providers[${index}].middleName`}
                                                type="text"
                                                onInput={handleInput}
                                                className="form-control"
                                                placeholder="Middle Name"
                                              />
                                            </Col>
                                            <Col md={2} xs={12} className="me-4">
                                              <Label check>
                                                Last Name
                                              </Label>
                                              <Field
                                                name={`Providers[${index}].lastName`}
                                                type="text"
                                                onInput={handleInput}
                                                className="form-control"
                                                placeholder="Last Name"
                                              />
                                              <ErrorMessage
                                                name={`Providers[${index}].lastName`}
                                                component="span"
                                                className="text-danger"
                                              />
                                            </Col>
                                            <Col md={2} xs={12} className="me-4">
                                              <Label check> Provider Tax Id </Label>
                                              <Field
                                                name={`Providers[${index}].providertaxId`}
                                                type="text"
                                                className="form-control"
                                                placeholder="Provider Tax ID"
                                              />
                                            </Col>
                                          </>
                                        )}
                                        {/* Always render Provider NPI Id */}
                                        <Col md={2} xs={12} className="me-4">
                                          <Label check>
                                            Provider NPI Id
                                          </Label>
                                          <Field
                                            name={`Providers[${index}].providerId`}
                                            type="text"
                                            className="form-control"
                                            placeholder="Provider ID"
                                          />
                                          <ErrorMessage
                                            name={`Providers[${index}].providerId`}
                                            component="span"
                                            className="text-danger"
                                          />
                                        </Col>
                                        <br />

                                        <div className="ms-2">
                                          <i
                                            className="fa fa-plus-square cursor-pointer"
                                            onClick={() =>
                                              push({
                                                firstName: '',
                                                middleName: '',
                                                lastName: '',
                                                providerId: '',
                                                providertaxId: ''
                                              })
                                            }
                                            style={{ fontSize: '20px', marginTop: '35px' }} // Adjust margin to align with the input field
                                          ></i>
                                        </div>
                                        {values.Providers.length > 1 && (
                                          <div className="ms-2">
                                            <i
                                              className="fa fa-times-circle-o cursor-pointer"
                                              onClick={() => remove(index)}
                                              style={{ fontSize: '22px', marginTop: '35px', color: 'red' }} // Apply similar styles as the plus icon
                                            ></i>
                                          </div>

                                        )}

                                      </div>
                                    </Row>
                                  ))}
                                </div>
                              )}
                            </FieldArray>
                          </Col>
                        )}
                        {companyType.includes('Group') && (
                          <Col md="12">
                            <FieldArray name="Group">
                              {({ push, remove }) => (
                                <div>
                                  <Label for="Group">
                                    <strong>Group Provider Details :</strong>
                                  </Label>
                                  <><br /></>
                                  {values.Group.map((Group, index) => (
                                    <Row key={index} className="d-flex mb-3">
                                      <div className="d-flex">
                                        {/* Render First Name, Middle Name, Last Name, and Provider Tax Id fields only if companyType includes 'Individual' */}

                                        {/* Always render Provider NPI Id */}
                                        <Col md={2} xs={12} className="me-4">
                                          <Label check>
                                            Provider NPI Id
                                          </Label>
                                          <Field
                                            name={`Group[${index}].providerId`}
                                            type="text"
                                            className="form-control"
                                            placeholder="Provider ID"
                                          />
                                          <ErrorMessage
                                            name={`Group[${index}].providerId`}
                                            component="span"
                                            className="text-danger"
                                          />
                                        </Col>
                                        <br />
                                        <div className="ms-2">
                                          <i
                                            className="fa fa-plus-square cursor-pointer"
                                            onClick={() =>
                                              push({
                                                providerId: '',
                                              })
                                            }
                                            style={{ fontSize: '20px', marginTop: '35px' }} // Adjust margin to align with the input field
                                          ></i>
                                        </div>
                                        {values.Group.length > 1 && (
                                          <div className="ms-2">
                                            <i
                                              className="fa fa-times-circle-o cursor-pointer"
                                              onClick={() => remove(index)}
                                              style={{ fontSize: '22px', marginTop: '35px', color: 'red' }} // Apply similar styles as the plus icon
                                            ></i>
                                          </div>
                                        )}
                                      </div>
                                    </Row>
                                  ))}
                                </div>
                              )}
                            </FieldArray>
                          </Col>
                        )}
                        {companyType.includes('Group') && (
                          <Col md={4} xs={12}>
                            <FormGroup>
                              <Label check> Groups <span>(Mention if it’s a Group of Company)</span></Label>
                              <Field name="Groups" type="text" className="form-control" placeholder="Enter the Groups" />
                              <ErrorMessage name="Groups" component="span" className="text-danger" />
                            </FormGroup>
                          </Col>
                        )}
                        <Col md={4} xs={12}>
                          <FormGroup>
                            <Label check>Currency</Label>
                            <Select
                              name="Currency"
                              options={CurrencyOptions}
                              defaultValue={CurrencyOptions.find((option) => option.value === 'USD')}
                              onChange={option => setFieldValue('Currency', option?.value)}
                              className="react-select"
                              classNamePrefix="select"
                            />
                            <ErrorMessage name="Currency" component="span" className="text-danger" />
                          </FormGroup>
                        </Col>
                        <Col md={4} xs={12}>
                          <FormGroup>
                            <Label check> Mobile No </Label>
                            <Field
                              name="MobileNo"
                              type="text"
                              className="form-control"
                              onInput={handleNumbers}
                              placeholder="Enter the Mobile No."
                              inputMode="numeric"
                              pattern="[0-9]*"
                              maxLength="16"
                            />
                            <ErrorMessage name="MobileNo" component="span" className="text-danger" />
                          </FormGroup>
                        </Col>
                        {/* <Col md={4} xs={12}>
                        <FormGroup>
                          <Label check> Address <span style={{ color: 'red' }}> * </span></Label>
                          <Field name="Address" type="text" className="form-control" placeholder="Enter the Address" />
                          <ErrorMessage name="Address" component="span" className="text-danger" />
                        </FormGroup>
                      </Col> */}
                        <Col md={4} xs={12}>
                          <FormGroup>
                            <Label check> City <span style={{ color: 'red' }}> * </span></Label>
                            <InputGroup>
                              <Field name="City" placeholder="Enter the City" type='text' className="form-control" />
                            </InputGroup>
                            <ErrorMessage name="City" component="span" className="text-danger" />
                          </FormGroup>
                        </Col>
                        <Col md={4} xs={12}>
                          <FormGroup>
                            <Label check>State <span style={{ color: 'red' }}> * </span></Label>
                            <Field name="State"
                              type="text"
                              onInput={handleInput}
                              className="form-control"
                              pattern="[A-Za-z]*"
                              placeholder="Enter the State" />
                            <ErrorMessage name="State" component="span" className="text-danger" />
                          </FormGroup>
                        </Col>
                        <Col md={4} xs={12}>
                          <FormGroup>
                            <Label check>Zip Code <span style={{ color: 'red' }}> * </span></Label>
                            <Field name="ZipCode" onInput={handleNumbers} inputMode="numeric" pattern="[0-9]*"
                              maxLength="7" type="text" className="form-control" placeholder="Enter the Zip Code" />
                            <ErrorMessage name="ZipCode" component="span" className="text-danger" />
                          </FormGroup>
                        </Col>
                        <Col md={4} xs={12}>
                          <FormGroup>
                            <Label check>Country <span style={{ color: 'red' }}> * </span></Label>
                            <Select
                              name="Country"
                              options={CountryOptions}
                              defaultValue={CountryOptions.find((option) => option.value === 'US')}
                              onChange={option => setFieldValue('Country', option?.value)}
                              className="react-select"
                              classNamePrefix="select"
                            />
                            <ErrorMessage name="Country" component="span" className="text-danger" />
                          </FormGroup>
                        </Col>

                        <Col md={4} xs={12}>
                          <FormGroup>
                            <Label check>Map Vendor <span style={{ color: 'red' }}> * </span></Label>
                            <Select
                              name="allocation_vendor_name"
                              options={vendorOptions}
                              isMulti
                              onChange={(options) => {
                                setFieldValue('allocation_vendor_name', options || []);
                              }}
                              className="react-select"
                              classNamePrefix="select"
                            />
                            <ErrorMessage name="allocation_vendor_name" component="span" className="text-danger" />
                          </FormGroup>
                        </Col>
                        <Col md={4} xs={12}>
                          <FieldArray name="Address">
                            {({ push, remove, form }) => (
                              <>
                                {form.values.Address.map((Address: string, index: number) => (
                                  <Row key={index} className="mb-3">
                                    <Col md={12} xs={12}>
                                      <Label>Address<span style={{ color: 'red' }}>*</span></Label>
                                      <div className="d-flex align-items-center">
                                        <Field name={`Address[${index}]`} as="textarea" className="form-control" placeholder="" />
                                        <Plus size={16} color="green" className="ms-2 cursor-pointer" onClick={() => push('')} />
                                        {form.values.Address.length > 1 && (
                                          <X size={16} color="red" className="ms-2 cursor-pointer" onClick={() => remove(index)} />
                                        )}
                                      </div>
                                      <ErrorMessage name={`Address[${index}]`} component="span" className="text-danger" />
                                    </Col>
                                  </Row>
                                ))}
                              </>
                            )}
                          </FieldArray>
                        </Col>
                      </Row>
                    </CardBody>
                  )}
                </Card>
                <Card className="shadow-sm mb-4">
                  <CardHeader
                    style={{
                      backgroundColor: '#B4B4B3',
                      cursor: 'pointer',
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      borderBottom: mainExpandedSections.insurance ? '1px solid #dee2e6' : 'none',
                      transition: 'all 0.3s ease'
                    }}
                    onClick={() => toggleMainSection('insurance')}
                    title={`Click to ${mainExpandedSections.insurance ? 'collapse' : 'expand'} Insurance`}
                  >
                    <CardTitle tag="h3" className="mb-0 d-flex align-items-center" style={{ color: '#333' }}>
                      {mainExpandedSections.insurance ? <ChevronDown size={20} className="me-2 text-primary" /> : <ChevronRight size={20} className="me-2 text-primary" />}
                      Insurance
                    </CardTitle>
                    {mainExpandedSections.insurance && (
                      <Button
                        color='primary'
                        size='sm'
                        className='d-flex align-items-center gap-2 rounded-pill px-3 border-0 shadow-sm'
                        onClick={(e) => {
                          e.stopPropagation();
                          navigate('/user-activity-stream');
                        }}
                        style={{ fontSize: '12px', fontWeight: 600, height: '32px', backgroundColor: '#1f33e4' }}
                      >
                        <Plus size={14} /> New Insurance
                      </Button>
                    )}
                  </CardHeader>
                  {mainExpandedSections.insurance && (
                    <CardBody>
                      <Row>
                        <Col md="12">
                          <FieldArray name="Insurance">
                            {({ push, remove }) => (
                              <div>
                                {values.Insurance.map((insurance, index) => (
                                  <Row key={index} className="d-flex mb-3">
                                    <div className="d-flex">
                                      <Col md={2} xs={12} className="me-4">
                                        <Label check> Insurance Name </Label>
                                        <Select
                                          isClearable
                                          name={`Insurance[${index}].insurance`}
                                          options={insuranceoption}
                                          classNamePrefix="select"
                                          onChange={(selectedOption) => {
                                            setFieldValue(`Insurance[${index}].insurance`, selectedOption ? selectedOption.value : '');
                                            handleinsuranceChange(selectedOption as SingleValue<Iinsuranceoption>, setFieldValue, index);
                                          }}
                                          className="form-control"
                                          placeholder="Select Insurance"
                                        />
                                      </Col>
                                      <Col md={2} xs={12} className="me-4">
                                        <Label check> Link </Label>
                                        <InputGroup>
                                          <Field
                                            name={`Insurance[${index}].link`}
                                            type="text"
                                            className="form-control"
                                            placeholder="url"
                                            disabled={!canEditLink || !editableLinkIndexes.includes(index)}
                                          />
                                          {canEditLink && (
                                            <InputGroupText
                                              className="cursor-pointer"
                                              title={editableLinkIndexes.includes(index) ? 'Lock link' : 'Edit link'}
                                              onClick={() => handleLinkEditToggle(index)}
                                            >
                                              {editableLinkIndexes.includes(index) ? <Lock size={14} /> : <Edit2 size={14} />}
                                            </InputGroupText>
                                          )}
                                        </InputGroup>
                                      </Col>
                                      <Col md={2} xs={12} className="me-4">
                                        <Label check> Username </Label>
                                        <Field
                                          name={`Insurance[${index}].Username`}
                                          type="text"
                                          className="form-control"
                                          placeholder="Username"
                                        />
                                      </Col>
                                      <Col md={2} xs={12} className="me-4">
                                        <Label check> Password </Label>
                                        <InputGroup>
                                          <Field
                                            name={`Insurance[${index}].password`}
                                            type={showPasswordIndex === index ? 'text' : 'password'}
                                            className="form-control"
                                            placeholder="Password"
                                          />
                                          <InputGroupText
                                            className="cursor-pointer"
                                            onClick={() => {
                                              setShowPasswordIndex(prevIndex => (prevIndex === index ? null : index));
                                            }}
                                          >
                                            {showPasswordIndex === index ? <EyeOff size={14} /> : <Eye size={14} />}
                                          </InputGroupText>
                                        </InputGroup>
                                      </Col>
                                      {values.Insurance[index].SoftwareName && (
                                        <Col md={2} xs={12} className="me-4">
                                          <Label check> Software Name </Label>
                                          <Field
                                            name={`Insurance[${index}].Software_Vendor`}
                                            type="text"
                                            className="form-control"
                                            placeholder="Software Name"
                                          />
                                        </Col>
                                      )}
                                      <Col md={2} xs={12} className="me-2">
                                        <FormGroup>
                                          <Label check>Status</Label>
                                          <div className="form-check form-switch form-check-success" style={{ marginTop: '8px' }}>
                                            <Input
                                              type="switch"
                                              name={`Insurance[${index}].status`}
                                              checked={values.Insurance[index].status === 'active'}
                                              onChange={(e) => {
                                                const newStatus = e.target.checked ? 'active' : 'inactive';
                                                setFieldValue(`Insurance[${index}].status`, newStatus);
                                              }}
                                            />
                                            <Label check>{values.Insurance[index].status === 'active' ? 'Active' : 'Inactive'}</Label>
                                          </div>
                                        </FormGroup>
                                      </Col>
                                      <div className="ms-2">
                                        <i
                                          className="fa fa-plus-square cursor-pointer"
                                          onClick={() =>
                                            push({
                                              insurance: '',
                                              Username: '',
                                              password: '',
                                              Software_Vendor: '',
                                              SoftwareName: false,
                                              link: '',
                                              status: 'active', // <-- Default for new entry
                                              bot_status: '',
                                            })
                                          }
                                          style={{ fontSize: '20px', marginTop: '35px' }}
                                        ></i>
                                      </div>
                                      {/* Clear button for the first index */}
                                      {index === 0 ? (
                                        <div className="ms-2">
                                          <i
                                            className="fa fa-times-circle-o cursor-pointer"
                                            title="Clear"
                                            onClick={() => {
                                              setFieldValue(`Insurance[0]`, {
                                                insurance: '',
                                                Username: '',
                                                password: '',
                                                Software_Vendor: '',
                                                SoftwareName: false,
                                                link: '',
                                                status: 'active', // <-- Reset with status
                                                bot_status: '',
                                              });
                                            }}
                                            style={{ fontSize: '20px', marginTop: '35px', color: 'red' }}
                                          ></i>
                                        </div>
                                      ) : (
                                        values.Insurance.length > 1 && (
                                          <div className="ms-2">
                                            <i
                                              className="fa fa-times-circle-o cursor-pointer"
                                              onClick={() => {
                                                remove(index);
                                                shiftEditableLinkIndexes(index);
                                              }}
                                              style={{ fontSize: '22px', marginTop: '35px', color: 'red' }}
                                            ></i>
                                          </div>
                                        )
                                      )}
                                    </div>
                                  </Row>
                                ))}
                              </div>
                            )}
                          </FieldArray>
                        </Col>
                      </Row>
                    </CardBody>
                  )}
                </Card>
                <Card className="shadow-sm mb-4">
                  <CardHeader
                    style={{
                      backgroundColor: '#B4B4B3',
                      cursor: 'pointer',
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      borderBottom: mainExpandedSections.contactDetails ? '1px solid #dee2e6' : 'none',
                      transition: 'all 0.3s ease'
                    }}
                    onClick={() => toggleMainSection('contactDetails')}
                    title={`Click to ${mainExpandedSections.contactDetails ? 'collapse' : 'expand'} Contact Details`}
                  >
                    <CardTitle tag="h3" className="mb-0 d-flex align-items-center" style={{ color: '#333' }}>
                      {mainExpandedSections.contactDetails ? <ChevronDown size={20} className="me-2 text-primary" /> : <ChevronRight size={20} className="me-2 text-primary" />}
                      Contact Details
                    </CardTitle>
                  </CardHeader>
                  {mainExpandedSections.contactDetails && (
                    <CardBody>
                      <Row>
                        <Col md={4} xs={12}>
                          <FormGroup>
                            <Label check> First Name </Label>
                            {/* <Label check> First Name <span style={{ color: 'red' }}> * </span></Label> */}
                            <Field name="FirstName" type="text" onInput={handleInput} className="form-control" placeholder="Enter the First Name" />
                            {/* <ErrorMessage name="FirstName" component="span" className="text-danger" /> */}
                          </FormGroup>
                        </Col>
                        <Col md={4} xs={12}>
                          <FormGroup>
                            <Label check> Last Name </Label>
                            <Field name="LastName" type="text" onInput={handleInput} className="form-control" placeholder="Enter the Last Name" />
                            {/* <ErrorMessage name="LastName" component="span" className="text-danger" /> */}
                          </FormGroup>
                        </Col>
                        <Col md={4} xs={12}>
                          <FormGroup>
                            <Label check> Position </Label>
                            <Field name="Position" type="text" className="form-control" placeholder="Enter the Position" />
                            {/* <ErrorMessage name="Position" component="span" className="text-danger" /> */}
                          </FormGroup>
                        </Col>
                        <Col md={4} xs={12}>
                          <FormGroup>
                            <Label check>Email </Label>
                            <Field name="Email" type="text" className="form-control" placeholder="Enter the Email" />
                            {/* <ErrorMessage name="Email" component="span" className="text-danger" /> */}
                          </FormGroup>
                        </Col>
                        <Col md={4} xs={12}>
                          <FormGroup>
                            <Label check> Phone</Label>
                            {/* <Label check> Phone <span style={{ color: 'red' }}> * </span> </Label> */}
                            <Field
                              name="Phone"
                              type="text"
                              className="form-control"
                              onInput={handleNumbers}
                              placeholder="Enter the Phone No."
                              inputMode="numeric"
                              pattern="[0-9]*"
                              maxLength="16"
                            />
                            <ErrorMessage name="Phone" component="span" className="text-danger" />
                          </FormGroup>
                        </Col>
                      </Row>
                    </CardBody>
                  )}
                </Card>
                {/* {localStorage.UserType === "MOS" && localStorage.Role === "Dev Admin" && (
                <Card>
                  <CardHeader style={{ backgroundColor: '#B4B4B3' }}>
                    <CardTitle tag="h3">Prompt Details</CardTitle>
                  </CardHeader>
                  <CardBody>
                    {renderPromptSection(
                      "Mapping Prompt",
                      mappingPrompts,
                      setMappingPrompts,
                      "Define prompts used for field mapping",
                      "mapping-prompt-tooltip"
                    )}
                  </CardBody>
                </Card>
                )} */}



                {/* System Prompt Section */}
                <Card className="shadow-sm mb-4">
                  <CardHeader
                    style={{
                      backgroundColor: '#B4B4B3',
                      cursor: 'pointer',
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      borderBottom: mainExpandedSections.systemPrompt ? '1px solid #dee2e6' : 'none',
                      transition: 'all 0.3s ease'
                    }}
                    onClick={() => toggleMainSection('systemPrompt')}
                    title={`Click to ${mainExpandedSections.systemPrompt ? 'collapse' : 'expand'} Client System Prompt`}
                  >
                    <CardTitle tag="h3" className="mb-0 d-flex align-items-center" style={{ color: '#333' }}>
                      {mainExpandedSections.systemPrompt ? <ChevronDown size={20} className="me-2 text-primary" /> : <ChevronRight size={20} className="me-2 text-primary" />}
                      Client System Prompt
                    </CardTitle>
                  </CardHeader>
                  {mainExpandedSections.systemPrompt && renderSystemPromptSection()}
                </Card>

                {/* Questions and instruction */}
                <Card className="shadow-sm mb-4">
                  <CardHeader
                    style={{
                      backgroundColor: '#B4B4B3',
                      cursor: 'pointer',
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      borderBottom: mainExpandedSections.questionsAndInstructions ? '1px solid #dee2e6' : 'none',
                      transition: 'all 0.3s ease'
                    }}
                    onClick={() => toggleMainSection('questionsAndInstructions')}
                    title={`Click to ${mainExpandedSections.questionsAndInstructions ? 'collapse' : 'expand'} Questions and instruction`}
                  >
                    <CardTitle tag="h3" className="mb-0 d-flex align-items-center" style={{ color: '#333' }}>
                      {mainExpandedSections.questionsAndInstructions ? <ChevronDown size={20} className="me-2 text-primary" /> : <ChevronRight size={20} className="me-2 text-primary" />}
                      Questions and instruction
                    </CardTitle>
                    {mainExpandedSections.questionsAndInstructions && (
                      <div style={{ width: '300px' }} onClick={(e) => e.stopPropagation()}>
                        <InputGroup className="shadow-sm rounded-pill overflow-hidden border" style={{ backgroundColor: '#fff' }}>
                          <InputGroupText className="bg-transparent border-0 pe-1">
                            <i className="fa fa-search text-muted"></i>
                          </InputGroupText>
                          <Input
                            placeholder="Search categories or fields..."
                            className="border-0 shadow-none bg-transparent ps-1"
                            style={{ height: '32px', fontSize: '13px' }}
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                          />
                          {searchTerm && (
                            <InputGroupText
                              className="bg-transparent border-0 cursor-pointer"
                              onClick={() => setSearchTerm('')}
                            >
                              <X size={14} className="text-muted" />
                            </InputGroupText>
                          )}
                        </InputGroup>
                      </div>
                    )}
                  </CardHeader>
                  {mainExpandedSections.questionsAndInstructions && (
                    <CardBody>
                      <Row>
                        <Col md={12}>
                          <div className="d-flex align-items-center justify-content-between mb-2">
                            <h4 className="mb-0">Select Fields <span style={{ color: 'red' }}> * </span></h4>
                            {(() => {
                              const allVisibleFields: string[] = [];
                              const searchLower = searchTerm.toLowerCase();

                              decryptedTemplateData.forEach(([sectionKey, sectionValue]) => {
                                const sectionFields = Array.isArray(sectionValue) ? sectionValue : Object.values(sectionValue);
                                const sectionFieldNames = sectionFields.map((field: any) => typeof field === 'object' ? field.field_name : field);

                                const matchesSection = sectionKey.toLowerCase().includes(searchLower);
                                const matchesFields = sectionFieldNames.some((name: string) => name.toLowerCase().includes(searchLower));

                                if (matchesSection || matchesFields) {
                                  const fieldsInThisSection = matchesSection
                                    ? sectionFieldNames
                                    : sectionFieldNames.filter((name: string) => name.toLowerCase().includes(searchLower));
                                  allVisibleFields.push(...fieldsInThisSection);
                                }
                              });

                              const isAllVisibleSelected = allVisibleFields.length > 0 && allVisibleFields.every(name => values.selectedFields.includes(name));
                              const someVisibleSelected = allVisibleFields.some(name => values.selectedFields.includes(name));

                              return (
                                <div
                                  className="d-flex align-items-center bg-light px-3 py-1 rounded-pill border shadow-sm"
                                  style={{
                                    cursor: 'pointer',
                                    transition: 'all 0.2s ease',
                                    backgroundColor: isAllVisibleSelected ? '#fff5f5' : '#f8f9fa'
                                  }}
                                  onClick={() => {
                                    const checked = !isAllVisibleSelected;
                                    let newSelectedFields = [...values.selectedFields];

                                    if (checked) {
                                      // Select only the visible fields that aren't already selected
                                      allVisibleFields.forEach(name => {
                                        if (!newSelectedFields.includes(name)) {
                                          newSelectedFields.push(name);
                                        }
                                      });

                                      // Pre-populate instructions for the newly selected fields
                                      decryptedTemplateData.forEach(([_, sectionValue]) => {
                                        const sectionFields = Array.isArray(sectionValue) ? sectionValue : Object.values(sectionValue);
                                        sectionFields.forEach((field: any) => {
                                          const fieldName = typeof field === 'object' ? field.field_name : field;
                                          if (allVisibleFields.includes(fieldName) && typeof field === 'object' && field.instruction) {
                                            if (!values.fieldInstructions?.[fieldName]) {
                                              setFieldValue(`fieldInstructions.${fieldName}`, field.instruction);
                                            }
                                          }
                                        });
                                      });
                                    } else {
                                      // Deselect only the visible fields
                                      newSelectedFields = newSelectedFields.filter(name => !allVisibleFields.includes(name));
                                    }
                                    setFieldValue('selectedFields', newSelectedFields);
                                  }}
                                >
                                  <div className="form-check mb-0 d-flex align-items-center p-0">
                                    <Input
                                      className="form-check-input custom-checkbox m-0"
                                      type="checkbox"
                                      id="select-all-global"
                                      checked={isAllVisibleSelected}
                                      readOnly
                                      style={{
                                        pointerEvents: 'none',
                                        position: 'static',
                                        width: '16px',
                                        height: '16px'
                                      }}
                                    />
                                    <Label
                                      for="select-all-global"
                                      className="ms-2 mb-0 cursor-pointer"
                                      style={{
                                        fontWeight: '600',
                                        color: isAllVisibleSelected ? '#dc3545' : '#1f33e4',
                                        userSelect: 'none',
                                        fontSize: '13px'
                                      }}
                                    >
                                      {isAllVisibleSelected ? 'Deselect All' : 'Select All'}
                                    </Label>
                                  </div>
                                </div>
                              );
                            })()}
                          </div>
                          <ErrorMessage name="selectedFields" component="span" className="text-danger" />
                          <div style={{ maxHeight: '700px', overflowY: 'auto', padding: '10px' }}>
                            {decryptedTemplateData
                              .filter(([sectionKey, sectionValue]: [string, any]) => {
                                const sectionFields = Array.isArray(sectionValue) ? sectionValue : Object.values(sectionValue);
                                const sectionFieldNames = sectionFields.map((field: any) => typeof field === 'object' ? field.field_name : field);

                                const searchLower = searchTerm.toLowerCase();
                                const matchesSection = sectionKey.toLowerCase().includes(searchLower);
                                const matchesFields = sectionFieldNames.some((name: string) => name.toLowerCase().includes(searchLower));

                                return matchesSection || matchesFields;
                              })
                              .map(([sectionKey, sectionValue]: [string, any], index: number) => {
                                const sectionFields = Array.isArray(sectionValue) ? sectionValue : Object.values(sectionValue);
                                const sectionFieldNames = sectionFields.map((field: any) => typeof field === 'object' ? field.field_name : field);

                                // If search term matches fields, we might want to only show matching fields or show all.
                                // Let's filter fields if there is a search term and it doesn't match the section name.
                                const searchLower = searchTerm.toLowerCase();
                                const matchesSection = sectionKey.toLowerCase().includes(searchLower);

                                const filteredFieldNames = matchesSection
                                  ? sectionFieldNames
                                  : sectionFieldNames.filter((name: string) => name.toLowerCase().includes(searchLower));

                                const isAllSelected = sectionFieldNames.every((fieldName: string) => values.selectedFields.includes(fieldName));

                                // Automatically expand section if searching and it has matches
                                const isSearching = searchTerm.length > 0;
                                const isExpanded = expandedSections[sectionKey] || (isSearching && filteredFieldNames.length > 0);

                                return (
                                  <div key={index} className="mb-3">
                                    <div
                                      className="d-flex align-items-center justify-content-between"
                                      style={{
                                        backgroundColor: isSearching && matchesSection ? '#e8f0fe' : '#f0f0f0',
                                        padding: '8px 12px',
                                        borderRadius: '8px',
                                        transition: 'all 0.2s ease',
                                        border: isSearching && matchesSection ? '1px solid #1f33e4' : '1px solid transparent'
                                      }}
                                    >
                                      <div className="d-flex align-items-center flex-grow-1">
                                        <FormGroup check className="mb-0 me-3" onClick={(e) => e.stopPropagation()}>
                                          <Input
                                            className="form-check-input custom-checkbox"
                                            type="checkbox"
                                            checked={isAllSelected}
                                            title={isAllSelected ? "Deselect all fields in this section" : "Select all fields in this section"}
                                            onChange={(e) => {
                                              const checked = e.target.checked;
                                              let newSelectedFields = [...values.selectedFields];
                                              if (checked) {
                                                // Build local instruction map for this section
                                                const sectionInstructionMap: Record<string, string> = {};
                                                sectionFields.forEach((field: any) => {
                                                  if (typeof field === 'object' && field.field_name) {
                                                    sectionInstructionMap[field.field_name] = field.instruction || '';
                                                  }
                                                });

                                                // Add all from this section and pre-populate instructions
                                                sectionFieldNames.forEach((name: string) => {
                                                  if (!newSelectedFields.includes(name)) {
                                                    newSelectedFields.push(name);
                                                  }
                                                  if (!values.fieldInstructions?.[name] && sectionInstructionMap[name]) {
                                                    setFieldValue(`fieldInstructions.${name}`, sectionInstructionMap[name]);
                                                  }
                                                });
                                              } else {
                                                // Remove all from this section
                                                newSelectedFields = newSelectedFields.filter(f => !sectionFieldNames.includes(f));
                                              }
                                              setFieldValue('selectedFields', newSelectedFields);
                                            }}
                                          />
                                        </FormGroup>
                                        <span
                                          style={{ fontWeight: '600', fontSize: '14px', color: '#333', cursor: 'pointer', userSelect: 'none' }}
                                          className="flex-grow-1"
                                          onClick={() => toggleSection(sectionKey)}
                                          title={`Click to ${isExpanded ? 'collapse' : 'expand'} ${sectionKey}`}
                                        >
                                          {isExpanded ? <ChevronDown size={16} className="me-1" /> : <ChevronRight size={16} className="me-1" />}
                                          {sectionKey}
                                        </span>
                                      </div>
                                      {isSearching && !matchesSection && (
                                        <span className="badge rounded-pill bg-primary" style={{ fontSize: '11px' }}>
                                          {filteredFieldNames.length} match{filteredFieldNames.length !== 1 ? 'es' : ''}
                                        </span>
                                      )}
                                    </div>
                                    {isExpanded && (
                                      <div className="ms-4 mt-2 border-start ps-3" style={{ borderColor: '#dee2e6' }}>
                                        {(() => {
                                          // Build a map of fieldName → preset instruction from API
                                          const instructionMap: Record<string, string> = {};
                                          sectionFields.forEach((field: any) => {
                                            if (typeof field === 'object' && field.field_name) {
                                              instructionMap[field.field_name] = field.instruction || '';
                                            }
                                          });
                                          return filteredFieldNames.map((fieldName: string, fieldIdx: number) => {
                                            const isChecked = values.selectedFields.includes(fieldName);
                                            const matchesField = isSearching && fieldName.toLowerCase().includes(searchLower);

                                            return (
                                              <Row key={fieldIdx} className="mb-2 align-items-center py-1 rounded" style={{ backgroundColor: matchesField ? '#f8f9fa' : 'transparent' }}>
                                                <Col md={4}>
                                                  <FormGroup check className="d-flex align-items-center mb-0">
                                                    <Input
                                                      className="form-check-input custom-checkbox"
                                                      type="checkbox"
                                                      checked={isChecked}
                                                      title={isChecked ? `Deselect ${fieldName}` : `Select ${fieldName}`}
                                                      onChange={(e) => {
                                                        const checked = e.target.checked;
                                                        let newSelectedFields = [...values.selectedFields];
                                                        if (checked) {
                                                          newSelectedFields.push(fieldName);
                                                          // Pre-populate instruction from API if not already set
                                                          if (!values.fieldInstructions?.[fieldName] && instructionMap[fieldName]) {
                                                            setFieldValue(`fieldInstructions.${fieldName}`, instructionMap[fieldName]);
                                                          }
                                                        } else {
                                                          newSelectedFields = newSelectedFields.filter(f => f !== fieldName);
                                                        }
                                                        setFieldValue('selectedFields', newSelectedFields);
                                                      }}
                                                      id={`field-${index}-${fieldIdx}`}
                                                    />
                                                    <Label check for={`field-${index}-${fieldIdx}`} className="ms-2 mb-0" style={{ cursor: 'pointer', fontSize: '13px', fontWeight: matchesField ? '600' : '400' }}>
                                                      {fieldName}
                                                    </Label>
                                                  </FormGroup>
                                                </Col>
                                                <Col md={8}>
                                                  <Input
                                                    type="textarea"
                                                    rows={1}
                                                    placeholder="Enter instruction..."
                                                    value={values.fieldInstructions?.[fieldName] ?? instructionMap[fieldName] ?? ''}
                                                    onChange={(e) => {
                                                      setFieldValue(`fieldInstructions.${fieldName}`, e.target.value);
                                                    }}
                                                    style={{ resize: 'vertical', fontSize: '12px', height: '40px', borderRadius: '6px' }}
                                                  />
                                                </Col>
                                              </Row>
                                            );
                                          });
                                        })()}
                                      </div>
                                    )}
                                  </div>
                                );
                              })}
                          </div>
                        </Col>
                      </Row>
                    </CardBody>
                  )}
                </Card>

                <Row>
                  <Col>
                    <div className="text-end">
                      <Link to={`/client`}>
                        <Button color="danger" className="me-3">Cancel</Button>
                      </Link>
                      <Button type="submit" color="success" className="me-3">Save and Create Admin</Button>
                    </div>
                  </Col>
                </Row>
              </Form>
            )}
          </Formik>
        </CardBody>
      </Fragment >
    </>
  );
};

export default Addclientadmin;